// classmom_client/src/services/http-interceptor.js - Fixed Version
import axios from 'axios';
import router from '@/router';

// Track if we're already handling a logout to prevent loops
let isHandlingLogout = false;

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    // Only add token if it exists - don't check auth status
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Only handle 401 errors and prevent logout loops
    if (error.response && error.response.status === 401 && !isHandlingLogout) {
      isHandlingLogout = true;
      
      // Clear auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Remove authorization header
      delete axios.defaults.headers.common['Authorization'];
      
      // Only redirect if not already on a login page
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/login') && !currentPath.includes('/register')) {
        // Check if this was a super admin session
        const userData = localStorage.getItem('user');
        let redirectPath = '/login';
        
        try {
          if (userData) {
            const user = JSON.parse(userData);
            if (user.role === 'super_admin') {
              redirectPath = '/super-admin/login';
            }
          }
        } catch (e) {
          // Use default redirect
        }
        
        router.push(redirectPath);
      }
      
      // Reset the flag after a delay
      setTimeout(() => {
        isHandlingLogout = false;
      }, 1000);
    }
    
    return Promise.reject(error);
  }
);

export default axios;